import React from 'react';
import PropTypes from 'prop-types';

const GoogleMap = ({
  title,
  latitude,
  longitude,
  ...rest
}) => (
  <iframe
    title={title}
    src={`https://www.google.com/maps/embed/v1/view?key=API_KEY&center=${latitude},${longitude}&zoom=14`}
    {...rest}
  />
);

GoogleMap.propTypes = {
  title: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
};

GoogleMap.defaultProps = {
  title: 'key',
};

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/GoogleMap/GoogleMap.jsx